import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconStarSvg } from "./IconStarSvg.mjs";
import { IconStarActiveSvg } from "./IconStarActiveSvg.mjs";
const IconStar = ({ active = false, ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: active ? IconStarActiveSvg : IconStarSvg, ...svgProps }) });
export {
  IconStar
};
